// src/resources/bookings/components/BookingStatusChip.tsx
import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";

export const BookingStatusChip = () => {
  const record = useRecordContext();
  if (!record) return null;

  const getStatusColor = (status: string) => {
    switch (status) {
      case "confirmed":
        return "success";
      case "created":
      case "awaiting_payment":
        return "warning";
      case "payment_received":
      case "started":
        return "info";
      case "cancelled":
      case "failed":
      case "payment_failed":
        return "error";
      default:
        return "default";
    }
  };

  const getStatusText = (status: string) => {
    return status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <Chip
      label={getStatusText(record.status)}
      color={getStatusColor(record.status)}
      size="small"
    />
  );
};
